<template>
  <main
    class="wrap-bg"
    :style="{ backgroundImage: `url(${host}h5-active/6/bg.png)` }"
  >
    <section
      class="content"
      :style="{ backgroundImage: `url(${host}h5-active/6/center.png)` }"
    >
      <div class="recharge-info">
        <h3>充值{{ config.recharge_money / 100 || "" }}元</h3>
        <div v-if="config.give_type === 1 || config.give_type === '1'">
          得<span>{{ config.recharge_money }}</span
          >书币+<span>{{ config.give_ticket }}</span
          >阅读劵
        </div>
        <div v-else>全站小说免费读({{ config.give_vip_days || 0 }}天)</div>
      </div>
      <img
        class="recharge-btn"
        :src="host + 'h5-active/6/btn.png'"
        @click="createOrder"
      />
    </section>
    <div class="tips">
      <p>-活动规则-</p>
      <p v-if="config.recharge_count != 9999">
        每一期活动单一用户仅能充值{{ config.recharge_count }}次
      </p>
      <p>虚拟商品购买后不可退换</p>
    </div>
  </main>
</template>

<script>
export default {
  props: {
    config: {
      type: Object,
    },
    host: String,
  },
  methods: {
    createOrder() {
      this.$emit("createOrder");
    },
  },
};
</script>

<style lang="less" scoped>
.wrap-bg {
  width: 100%;
  height: 100vh;
  min-height: 667px;
  max-height: 820px;
  position: relative;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}
.content {
  position: absolute;
  top: 27.5%;
  left: 50%;
  transform: translateX(-50%);
  width: 300px;
  height: 360px;
  background-size: cover;
  background-position: center;
}
.recharge-info {
  padding: 150px 0 32px;
  color: #fff;
  font-size: 21px;
  h3 {
    font-weight: bold;
    font-size: 35px;
    color: #f9e4a8;
    margin-bottom: 15px;
    text-align: center;
  }
  div {
    white-space: nowrap;
    text-align: center;
  }
}
.recharge-btn {
  display: block;
  width: 200px;
  height: auto;
  margin: 0 auto;
}
.tips {
  font-weight: bold;
  position: absolute;
  bottom: 40px;
  left: 0;
  width: 100%;
  font-size: 16px;
  color: #c02617;
  z-index: 1;
  line-height: 26px;
  p {
    text-align: center;
  }
}
</style>
